/** App UI languages — globe sheet picker (native labels). */
export const APP_LANGUAGES = [
  { code: "en", nativeLabel: "English" },
  { code: "de", nativeLabel: "Deutsch" },
  { code: "es", nativeLabel: "Español" },
  { code: "fr", nativeLabel: "Français" },
];

export function getAppLanguages() {
  return [...APP_LANGUAGES];
}
